<div class="layout-container" [class.sidebar-collapsed]="sidebarCollapsed">
  <!-- Header -->
  <header class="header">
    <div class="header-left">
      <button class="sidebar-toggle" (click)="toggleSidebar()" aria-label="Toggle sidebar"
        [attr.aria-pressed]="sidebarCollapsed">
        <mat-icon>menu</mat-icon>
      </button>
      <div class="logo">
        <mat-icon class="logo-icon">storefront</mat-icon>
        <span class="logo-text">{{ businessName }}</span>
      </div>
    </div>

    <div class="header-right">
      <!-- <button class="icon-button" aria-label="Search" (click)="openSearch()">
        <mat-icon>search</mat-icon>
      </button> -->
      <button class="icon-button workspace-button" aria-label="Open orders workspace" matTooltip="Open orders"
        (click)="toggleOrdersWorkspace()" [attr.aria-expanded]="ordersWorkspaceOpen"
        *appHasPermission="['pos.access', 'order.read']; mode: 'any'">
        <mat-icon [matBadge]="heldOrdersCount" matBadgeColor="warn" matBadgeSize="small"
          [matBadgeHidden]="heldOrdersCount === 0" aria-hidden="false">
          receipt_long
        </mat-icon>
      </button>
      <button class="icon-button" aria-label="Keyboard shortcuts" matTooltip="Keyboard shortcuts"
        (click)="toggleShortcutsPanel()" [attr.aria-expanded]="shortcutsOpen">
        <mat-icon>help_outline</mat-icon>
      </button>
      <button class="icon-button notification-button" aria-label="Notifications" (click)="toggleNotificationsPanel()"
        [attr.aria-expanded]="notificationsOpen">
        <mat-icon [matBadge]="notificationCount" matBadgeColor="warn" matBadgeSize="small"
          [matBadgeHidden]="notificationCount === 0" aria-hidden="false">
          notifications
        </mat-icon>
      </button>
      <ng-container *ngIf="(siteOptions$ | async) as siteOptions; else siteLoading">
        <ng-container *ngIf="(activeSite$ | async) as activeSite">
          <ng-container *ngIf="(canSwitchSites$ | async); else lockedSite">
            <button class="site-button" [matMenuTriggerFor]="siteSwitcherMenu" #siteSwitcherMenuTrigger="matMenuTrigger"
              (menuOpened)="onSiteSwitcherMenuOpened()"
              [disabled]="(isLoadingSites$ | async) === true">
              <mat-icon>storefront</mat-icon>
              <span>{{ activeSite?.name || 'Select site' }}</span>
              <mat-icon>arrow_drop_down</mat-icon>
            </button>
          </ng-container>
          <ng-template #lockedSite>
            <div class="site-pill">
              <mat-icon>storefront</mat-icon>
              <span>{{ activeSite?.name || 'Site not assigned' }}</span>
            </div>
          </ng-template>

          <mat-menu #siteSwitcherMenu="matMenu" class="site-switcher-menu">
            <button mat-menu-item *ngFor="let site of siteOptions" (click)="setActiveSite(site.id)"
              [disabled]="site.id === (activeSite?.id || '')">
              <span>{{ site.name }}</span>
            </button>
          </mat-menu>
        </ng-container>
      </ng-container>
      <ng-template #siteLoading>
        <div class="site-pill skeleton">
          <mat-icon>storefront</mat-icon>
          <span>Loading site…</span>
        </div>
      </ng-template>
      <button class="user-menu" [matMenuTriggerFor]="userMenu" #userMenuTrigger="matMenuTrigger"
        (menuOpened)="onUserMenuOpened()">
        <div class="user-avatar">{{ userInitials }}</div>
        <div class="user-info">
          <span class="user-name">{{ userName }}</span>
          <span class="user-role">{{ userRole }}</span>
        </div>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #userMenu="matMenu" class="user-dropdown" xPosition="before" yPosition="below" [overlapTrigger]="false">
        <button mat-menu-item routerLink="/profile">
          <mat-icon>person</mat-icon>
          <span>Profile</span>
        </button>
        <button mat-menu-item routerLink="/settings">
          <mat-icon>settings</mat-icon>
          <span>Settings</span>
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>Logout</span>
        </button>
      </mat-menu>
    </div>
  </header>

  <!-- Sidebar -->
  <aside class="sidebar" [class.collapsed]="sidebarCollapsed">
    <div class="sidebar-search" [class.hidden]="sidebarCollapsed">
      <mat-icon class="search-icon">search</mat-icon>
      <input
        #navSearchInput
        type="text"
        class="search-input"
        placeholder="Search menu…"
        [(ngModel)]="navSearchQuery"
        autocomplete="off"
        aria-label="Search navigation"
      />
      <button *ngIf="navSearchQuery" class="search-clear" (click)="clearNavSearch()" aria-label="Clear search" type="button">
        <mat-icon>close</mat-icon>
      </button>
      <span class="search-hint" *ngIf="!navSearchQuery">Ctrl + K</span>
    </div>

    <nav class="sidebar-nav">
      <a *ngFor="let link of filteredPrimaryLinks" [routerLink]="link.route" [class.active]="isLinkActive(link)"
        class="sidebar-link" [attr.title]="link.title">
        <mat-icon>{{ link.icon }}</mat-icon>
        <span class="link-text">{{ link.label }}</span>
      </a>

      <div class="sidebar-section" *ngFor="let section of filteredSidebarSections">
        <div class="section-title">
          <span>{{ section.label }}</span>
        </div>
        <a *ngFor="let link of section.links" [routerLink]="link.route" [class.active]="isLinkActive(link)"
          class="sidebar-link" [attr.title]="link.title">
          <mat-icon>{{ link.icon }}</mat-icon>
          <span class="link-text">{{ link.label }}</span>
        </a>
      </div>

      <div class="sidebar-no-results" *ngIf="navSearchQuery && filteredPrimaryLinks.length === 0 && filteredSidebarSections.length === 0">
        <mat-icon>search_off</mat-icon>
        <span>No results for "{{ navSearchQuery }}"</span>
      </div>
    </nav>
  </aside>

  <!-- Main Content -->
  <main class="main-content">
    <!-- Page toolbar (back button + icon + title + actions) driven by PageHeaderService -->
    <div class="page-toolbar" *ngIf="(pageHeader.config$ | async) as header">
      <div class="page-toolbar__title">
        <button *ngIf="header.backRoute" mat-icon-button [routerLink]="header.backRoute"
          [matTooltip]="header.backTooltip || 'Back'" class="page-toolbar__back" aria-label="Back">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <button *ngIf="!header.backRoute && header.backHandler" mat-icon-button (click)="header.backHandler()"
          [matTooltip]="header.backTooltip || 'Back'" class="page-toolbar__back" aria-label="Back">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <mat-icon *ngIf="header.icon" class="page-toolbar__icon">{{ header.icon }}</mat-icon>
        <h1 class="page-toolbar__heading">{{ header.title }}</h1>
        <span class="page-toolbar__badge"
          *ngIf="header.badge !== undefined && header.badge !== null && header.badge !== ''">
          {{ header.badge }}
        </span>
      </div>

      <div class="page-toolbar__actions" *ngIf="header.actions?.length">
        <ng-container *ngFor="let action of header.actions; trackBy: trackByAction">
          <ng-container *ngIf="!isActionHidden(action)">
            <ng-container *ngIf="action.permission as perm; else noPermAction">
              <ng-container *appHasPermission="perm; mode: action.permissionMode || 'any'">
                <ng-container *ngTemplateOutlet="actionButton; context: { $implicit: action }"></ng-container>
              </ng-container>
            </ng-container>
            <ng-template #noPermAction>
              <ng-container *ngTemplateOutlet="actionButton; context: { $implicit: action }"></ng-container>
            </ng-template>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- Content -->
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </main>

  <!-- Reusable action button renderer for the page toolbar -->
  <ng-template #actionButton let-action>
    <button *ngIf="!action.variant || action.variant === 'primary'" mat-flat-button color="primary" type="button"
      class="page-toolbar__action-primary" [disabled]="isActionDisabled(action)" [matTooltip]="action.tooltip || ''"
      (click)="action.handler()">
      <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
      <span *ngIf="actionLabel(action)">{{ actionLabel(action) }}</span>
    </button>
    <button *ngIf="action.variant === 'stroked'" mat-stroked-button type="button" [disabled]="isActionDisabled(action)"
      [matTooltip]="action.tooltip || ''" (click)="action.handler()">
      <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
      <span *ngIf="actionLabel(action)">{{ actionLabel(action) }}</span>
    </button>
    <button *ngIf="action.variant === 'icon'" mat-icon-button type="button" [disabled]="isActionDisabled(action)"
      [matTooltip]="action.tooltip || ''" [attr.aria-label]="actionLabel(action)" (click)="action.handler()">
      <mat-icon>{{ action.icon }}</mat-icon>
    </button>
  </ng-template>

  <!-- Footer -->
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-left">
        <span class="version">Optwaves Restaurant v{{ version }}</span>
        <span class="separator">|</span>
        <span class="copyright">© 2025 Optwaves Restaurant. All rights reserved.</span>
      </div>
      <div class="footer-right">
        <a routerLink="/legal/privacy" class="footer-link">Privacy Policy</a>
        <span class="separator">•</span>
        <a routerLink="/legal/terms" class="footer-link">Terms of Service</a>
        <span class="separator">•</span>
        <a routerLink="/legal/support" class="footer-link">Support</a>
      </div>
    </div>
  </footer>
</div>

<div class="shortcuts-workspace" *ngIf="shortcutsOpen">
  <button type="button" class="workspace-overlay" aria-label="Close keyboard shortcuts"
    (click)="closeShortcutsPanel()"></button>
  <aside class="workspace-panel" role="dialog" aria-modal="true" aria-label="Keyboard shortcuts" tabindex="-1">
    <div class="workspace-hero">
      <div class="hero-icon">
        <mat-icon>keyboard</mat-icon>
      </div>
      <div class="hero-copy">
        <p class="hero-title">Keyboard Shortcuts</p>
        <p class="hero-subtitle">Work the till without the mouse</p>
      </div>
      <div class="hero-actions">
        <button type="button" class="close-button" aria-label="Close keyboard shortcuts"
          (click)="closeShortcutsPanel()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="workspace-body">
      <p class="shortcuts-hint">
        <mat-icon>info</mat-icon>
        These function keys are available on the POS checkout screen.
      </p>

      <div class="shortcut-row" *ngFor="let shortcut of shortcuts">
        <kbd class="keycap">{{ shortcut.key }}</kbd>
        <div class="shortcut-icon">
          <mat-icon>{{ shortcut.icon }}</mat-icon>
        </div>
        <div class="shortcut-text">
          <p class="shortcut-action">{{ shortcut.action }}</p>
          <span class="shortcut-description">{{ shortcut.description }}</span>
        </div>
      </div>
    </div>

    <button type="button" class="view-all" (click)="openUserGuide()">
      View full user guide
      <mat-icon>chevron_right</mat-icon>
    </button>
  </aside>
</div>

<div class="notification-workspace" *ngIf="notificationsOpen">
  <button type="button" class="workspace-overlay" aria-label="Close notifications workspace"
    (click)="closeNotificationsPanel()"></button>
  <aside class="workspace-panel" role="dialog" aria-modal="true" aria-label="Notifications workspace" tabindex="-1">
    <div class="workspace-hero">
      <div class="hero-icon">
        <mat-icon>notifications_active</mat-icon>
      </div>
      <div class="hero-copy">
        <p class="hero-title">Notifications</p>
        <p class="hero-subtitle">Stock and supplier updates in real time</p>
        <p class="hero-updated" *ngIf="lastNotificationsRefresh">
          Updated {{ lastNotificationsRefresh | date: 'shortTime' }}
        </p>
      </div>
      <div class="hero-actions">
        <button type="button" class="link-button" (click)="refreshNotifications()" [disabled]="notificationsLoading">
          {{ notificationsLoading ? 'Refreshing...' : 'Refresh' }}
        </button>
        <button type="button" class="link-button" (click)="markAllNotificationsAsRead()"
          [disabled]="notificationCount === 0">
          Mark all as read
        </button>
        <button type="button" class="close-button" aria-label="Close notifications" (click)="closeNotificationsPanel()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="workspace-body">
      <div class="workspace-state" *ngIf="notificationsLoading">
        <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
        <p>Loading your notifications...</p>
      </div>

      <div class="workspace-state" *ngIf="!notificationsLoading && notificationsError">
        <mat-icon>error_outline</mat-icon>
        <p>{{ notificationsError }}</p>
        <button type="button" class="link-button" (click)="refreshNotifications()">Try again</button>
      </div>

      <div class="workspace-state"
        *ngIf="!notificationsLoading && !notificationsError && notificationGroups.length === 0">
        <mat-icon>mark_email_read</mat-icon>
        <p>You're all caught up.</p>
      </div>

      <ng-container *ngIf="!notificationsLoading && !notificationsError && notificationGroups.length">
        <div class="notification-group" *ngFor="let group of notificationGroups">
          <div class="group-header">
            <div class="group-title">
              <div class="group-icon">
                <mat-icon>{{ group.accentIcon }}</mat-icon>
              </div>
              <div>
                <p>{{ group.title }}</p>
                <span>{{ group.subtitle }}</span>
              </div>
            </div>
            <span class="group-badge" *ngIf="countUnread(group.items) > 0">
              {{ countUnread(group.items) }} new
            </span>
          </div>

          <div class="notification-item" *ngFor="let item of group.items; trackBy: trackByNotification"
            [class.unread]="!item.isRead" role="button" tabindex="0" (click)="openNotificationDetail(item)"
            (keyup.enter)="openNotificationDetail(item)" (keyup.space)="openNotificationDetail(item)">
            <div class="item-avatar" [class.stock]="item.category === 'stock'"
              [class.supplier]="item.category === 'supplier'" [class.product]="item.category === 'product'">
              <img *ngIf="item.actor?.avatarUrl" [src]="item.actor?.avatarUrl" [alt]="item.actor?.name" />
              <span *ngIf="!item.actor?.avatarUrl">{{ getAvatarInitials(item.actor?.name) }}</span>
            </div>
            <div class="item-content">
              <div class="item-head">
                <div class="actor-details">
                  <span class="actor-name">{{ item.actor?.name }}</span>
                  <span class="actor-role" *ngIf="item.actor?.role">• {{ item.actor?.role }}</span>
                </div>
                <span class="time">{{ item.timeAgo }}</span>
              </div>
              <p class="item-title">{{ item.title }}</p>
              <p class="item-message">{{ item.message }}</p>
              <div class="item-meta" *ngIf="item.metadata || item.fileName">
                <span *ngIf="item.metadata">{{ item.metadata }}</span>
                <span *ngIf="item.fileName">
                  {{ item.fileName }}
                  <span class="muted" *ngIf="item.fileSize">{{ item.fileSize }}</span>
                </span>
              </div>
              <div class="item-chip" *ngIf="item.chip">
                <span class="chip" [ngClass]="item.chip.tone">{{ item.chip.label }}</span>
              </div>
              <div class="item-actions" *ngIf="item.actions?.length">
                <button type="button" class="action-button" *ngFor="let action of item.actions"
                  [ngClass]="action.variant || 'secondary'" (click)="handleNotificationAction($event, action, item)">
                  {{ action.label }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <button type="button" class="view-all" (click)="viewAllNotifications()">
      View all notifications
      <mat-icon>chevron_right</mat-icon>
    </button>
  </aside>
</div>

<div class="orders-workspace" *ngIf="ordersWorkspaceOpen">
  <button type="button" class="workspace-overlay" aria-label="Close open orders workspace"
    (click)="closeOrdersWorkspace()"></button>
  <aside class="workspace-panel" role="dialog" aria-modal="true" aria-label="Open orders workspace" tabindex="-1">
    <div class="workspace-hero">
      <div class="hero-icon">
        <mat-icon>receipt_long</mat-icon>
      </div>
      <div class="hero-copy">
        <p class="hero-title">Open Orders</p>
        <p class="hero-subtitle">Held &amp; running bills — tap to resume</p>
      </div>
      <div class="hero-actions">
        <button type="button" class="link-button" (click)="refreshHeldOrders()" [disabled]="heldOrdersLoading">
          {{ heldOrdersLoading ? 'Refreshing...' : 'Refresh' }}
        </button>
        <button type="button" class="close-button" aria-label="Close open orders" (click)="closeOrdersWorkspace()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="workspace-body">
      <div class="workspace-state" *ngIf="heldOrdersLoading && heldOrders.length === 0">
        <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
        <p>Loading open orders...</p>
      </div>

      <div class="workspace-state" *ngIf="!heldOrdersLoading && heldOrdersError">
        <mat-icon>error_outline</mat-icon>
        <p>{{ heldOrdersError }}</p>
        <button type="button" class="link-button" (click)="refreshHeldOrders()">Try again</button>
      </div>

      <div class="workspace-state" *ngIf="!heldOrdersLoading && !heldOrdersError && heldOrders.length === 0">
        <mat-icon>inbox</mat-icon>
        <p>No open orders right now.</p>
        <button type="button" class="ws-primary" (click)="startNewSale()">
          <mat-icon>add</mat-icon><span>Start a sale</span>
        </button>
      </div>

      <div class="orders-grid" *ngIf="!heldOrdersError && heldOrders.length > 0">
        <div class="order-card-wrap" *ngFor="let order of heldOrders; trackBy: trackByOrder">
          <button type="button" class="order-card-remove" *ngIf="canRemoveHeldOrder"
            [disabled]="removingOrderId === order.id" title="Remove from open orders"
            aria-label="Remove from open orders" (click)="removeHeldOrder(order, $event)">
            <mat-icon *ngIf="removingOrderId !== order.id">delete</mat-icon>
            <mat-icon *ngIf="removingOrderId === order.id" class="spin">progress_activity</mat-icon>
          </button>

          <button type="button" class="order-card" (click)="resumeHeldOrder(order)">
            <div class="order-card__top">
              <strong>{{ order.hold_label || order.reservation_guest_name || ('#' + (order.daily_number ?? order.order_number)) }}</strong>
              <span class="order-badge" *ngIf="order.reservation_reference">
                <mat-icon>event_seat</mat-icon> Reservation
              </span>
            </div>

            <div class="order-card__meta">
              <span *ngIf="order.table_number"><mat-icon>table_restaurant</mat-icon> Table {{ order.table_number }}</span>
              <span *ngIf="order.customer_name"><mat-icon>person</mat-icon> {{ order.customer_name }}</span>
              <span><mat-icon>lunch_dining</mat-icon> {{ heldItemCount(order) }} item(s)</span>
            </div>

            <div class="order-card__foot">
              <span class="time">{{ order.created_at | date: 'MMM d, h:mm a' }}</span>
              <span class="total">{{ formatMoney(order.total) }}</span>
            </div>

            <div class="order-card__resume">
              <mat-icon>play_arrow</mat-icon> Resume
            </div>
          </button>
        </div>
      </div>
    </div>

    <button type="button" class="view-all" (click)="startNewSale()">
      New sale
      <mat-icon>add</mat-icon>
    </button>
  </aside>
</div>
